import React from 'react';

import find from 'lodash/find';

import {DetailPageGenericPoliciesSidebar} from 'app/components/general/DetailPageGenericPoliciesSidebar';
import {
  useAttachPolicyToProcess,
  useDetachPolicyFromProcess,
} from 'app/policies/api';
import {
  convertLocationParamsToFetchParams,
  useProcesses,
} from 'app/process/api';
import {UNLIMITED_PAGE_SIZE} from 'app/utils/constants';

import type {DetailPolicySerializedType} from 'sweet-types';

type Props = {
  policy: DetailPolicySerializedType;
};

export function PolicyProcessesSidebar({policy}: Props) {
  const {data} = useProcesses({
    policy_id: policy.id,
    fields: [
      'name',
      'url',
      'id',
      'html_url',
      'edited_at',
      'created_at',
      'can_edit',
      'current_version',
      'policies',
    ],
    ordering: 'name',
    page_size: UNLIMITED_PAGE_SIZE.toString(),
  });
  const [attachPolicyToProcess] = useAttachPolicyToProcess();
  const [detachPolicyFromProcess] = useDetachPolicyFromProcess();
  return (
    <DetailPageGenericPoliciesSidebar
      attachedItems={data?.results || []}
      detailPageObjectId={policy.id}
      closeUrl={policy.html_url}
      detailPageContentType={'policy'}
      sidebarContentType={'proceduregroup'}
      showFilterField={policy.can_edit}
      canEdit={policy.can_edit}
      useDataHook={useProcesses}
      onAttach={(item) => {
        return attachPolicyToProcess({
          genericLinks: [
            {
              policy: policy.url,
              process: item.url,
            },
          ],
        });
      }}
      onRemove={(item) => {
        const linkedDocument = find(item.policies, {
          url: policy.url,
        });
        if (linkedDocument != null) {
          return detachPolicyFromProcess(linkedDocument.link_url);
        }
        throw 'Linked document not found';
      }}
      paramsConverter={convertLocationParamsToFetchParams}
    />
  );
}
